module.exports = __webpack_public_path__ + "media/assets/images/icon-checkmark-green-e810e4b0fad3e128b8c515b623251268.svg";